import { Component } from "@angular/core";
import { Subject } from "rxjs";

export type IsLoading = boolean
const isLoadingSubject = new Subject<IsLoading>();
export const setIsLoading = (isLoading: IsLoading) => isLoadingSubject.next(isLoading);

@Component({
	selector: 'app-loading-overlay',
	templateUrl: './app-loading-overlay.component.html',
	styleUrls: ['./app-loading-overlay.component.scss']
})
export class AppLoadingOverlay {
	public isLoading: boolean = false;

	constructor() {
		isLoadingSubject.subscribe(isLoading => this.isLoading = isLoading);
	}
}